/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Member Schema
 * @export
 * @interface MemberRelative
 */
export interface MemberRelative {
    /**
     * Member Relative ID
     * @type {string}
     * @memberof MemberRelative
     */
    id: string;
    /**
     * Member ID
     * @type {string}
     * @memberof MemberRelative
     */
    memberId: string;
    /**
     * Account ID
     * @type {string}
     * @memberof MemberRelative
     */
    accountId: string | null;
    /**
     * Given Name
     * @type {string}
     * @memberof MemberRelative
     */
    givenName: string;
    /**
     * Family Name
     * @type {string}
     * @memberof MemberRelative
     */
    familyName: string;
    /**
     * Relationship to Member
     * @type {string}
     * @memberof MemberRelative
     */
    relationshipToMember: string;
    /**
     * Created Date
     * @type {Date}
     * @memberof MemberRelative
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MemberRelative
     */
    updatedDate: Date;
}

/**
 * Check if a given object implements the MemberRelative interface.
 */
export function instanceOfMemberRelative(value: object): value is MemberRelative {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('relationshipToMember' in value) || value['relationshipToMember'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MemberRelativeFromJSON(json: any): MemberRelative {
    return MemberRelativeFromJSONTyped(json, false);
}

export function MemberRelativeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberRelative {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'memberId': json['member_id'],
        'accountId': json['account_id'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'relationshipToMember': json['relationship_to_member'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MemberRelativeToJSON(value?: MemberRelative | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'member_id': value['memberId'],
        'account_id': value['accountId'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'relationship_to_member': value['relationshipToMember'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

